import Buy from "./buy";

export default Buy